import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Typography from "@material-ui/core/Typography";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import {NotificationManager} from "react-notifications";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarExport,
} from '@material-ui/data-grid';
import TextInput from "../form/input/TextInput";
import {Link} from "react-router-dom";
import {useDashboardStyles, BRAND} from "./dashboardStyles";

function CustomToolbar() {
    return (
        <GridToolbarContainer style={{padding: 8}}>
            <GridToolbarExport csvOptions={{utf8WithBom: true}}/>
        </GridToolbarContainer>
    );
}

const useLocalStyles = makeStyles((theme) => ({
    controlsRow: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(2),
        flexWrap: "wrap",
        marginBottom: theme.spacing(3),
    },
    yearInput: {
        flex: "0 0 220px",
        [theme.breakpoints.down("xs")]: {
            flex: "1 1 auto",
        },
    },
    dataGridWrap: {
        height: 480,
        width: "100%",
        background: "#ffffff",
        border: `1px solid ${BRAND.goldSoft}`,
        borderRadius: 10,
        overflow: "hidden",
        "& .MuiDataGrid-root": {
            border: 0,
        },
        "& .MuiDataGrid-columnHeaders": {
            background: BRAND.creamSoft,
            borderBottom: `1px solid ${BRAND.goldSoft}`,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            color: BRAND.deep,
            fontSize: "0.85rem",
        },
        "& .MuiDataGrid-cell": {
            fontSize: "0.9rem",
        },
    },
    helperLink: {
        marginTop: theme.spacing(2.5),
        padding: theme.spacing(1.5, 2),
        background: BRAND.goldBg,
        border: `1px solid ${BRAND.goldSoft}`,
        borderRadius: 8,
        color: BRAND.deep,
        fontSize: "0.9rem",
        "& a": {
            color: BRAND.deep,
            fontWeight: 600,
            textDecoration: "underline",
            textUnderlineOffset: 2,
        },
    },
}));

const columns = [
    {
        field: 'deceased',
        headerName: 'Meno a priezvisko zosnuleého',
        width: 150,
        editable: false,
    },
    {
        field: 'd_birth',
        headerName: 'Dátum narodenia',
        width: 150,
        editable: false,
    },
    {
        field: 'd_place_birth',
        headerName: 'Miesto narodenia',

        width: 150,
        editable: false,
    },
    {
        field: 'd_death',
        headerName: 'Dátum úmrtia',
        width: 150,
        editable: false,
    },
    {
        field: 'd_place_death',
        headerName: 'Miesto úmrtia',
        width: 150,
        editable: false,
    },
    {
        field: 'date_funeral',
        headerName: 'Dátum a čas pohrebu',
        width: 200,
        editable: false,
    },
    {
        field: 'd_id',
        headerName: 'Rodné číslo',

        width: 150,
        editable: false,
    }, {
        field: 'autopsy',
        headerName: 'Pitva',
        width: 150,
        editable: false,
    },
    {
        field: 'd_dangerous_disease',
        headerName: 'Úmrtie na nebezpečnú chorobu',
        width: 150,
        editable: false,
    },
    {
        field: 'planned_pickup',
        headerName: 'Dátum a čas prevzatia',
        width: 150,
        editable: false,
    }, {
        field: 'items',
        headerName: 'Odovzdane doklady a osobné veci',
        width: 150,
        editable: false,
    },
    {
        field: 'placement_fridge',
        headerName: 'Dátum a čas uloženia do chlad. zaria.',
        width: 150,
        editable: false,
    },
    {
        field: 'car_id',
        headerName: 'ŠPZ prepravujúceho vozidla',

        width: 150,
        editable: false,
    }, {
        field: 'temperature',
        headerName: 'Teplota (C)',
        width: 150,
        editable: false,
    },
    {
        field: 'disinfection',
        headerName: 'Čistenie a dezinfekcia chladiaceho zariadenia a vozidla',
        width: 150,
        editable: false,
    },
    {
        field: 'disinfection_date',
        headerName: 'Čistenie a dezinfekcia chladiaceho zariadenia a vozidla, dátum a čas',
        width: 150,
        editable: false,
    }, {
        field: 'employee',
        headerName: 'Kto vybavuje pohreb (zamestnanec)',
        width: 150,
        editable: false,
    }, {
        field: 'employee_money',
        headerName: 'Kto prevzal peniaze za pohreb (zamestnanec)',
        width: 150,
        editable: false,
    },
    {
        field: 'employee_transfer',
        headerName: 'Kto zabezpečil prevoz zosnulého (zamestnanec)',
        width: 150,
        editable: false,
    },
     {
        field: 'employee_clothes',
        headerName: 'Kto obliekal zosnulého (zamestnanec)',
        width: 150,
        editable: false,
    },
      {
        field: 'employee_funeral',
        headerName: 'Kto bol na pohrebe (zamestnanec)',
        width: 150,
        editable: false,
    },
    {
        field: 'placement_of_decedent',
        headerName: 'Miesto, kde sú uložené ľudské ostatky pred pohrebom',
        width: 150,
        editable: false,
    },
    {
        field: 'urn_number',
        headerName: 'Číslo urny',
        width: 120,
        editable: false,
    },
    {
        field: 'cremation_datetime',
        headerName: 'Dátum a čas kremácie',
        width: 160,
        editable: false,
    },
];

export default function ExportEvidence(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();

    const [values, setValues] = useState([]);
    const [year, setYear] = useState('');

    const handleFetchYear = () => {
        if (!year) {
            NotificationManager.error('Zvoľte rok!', 'Chyba', 5000);
            return;
        }
        UserService.getGeneratedEvidence(year).then(
            (response) => {
                let rows = response.data.map( (fun, index) => {
                    let row = {};
                    row.id = index;
                    row.deceased = fun.deceased;
                    row.d_birth = fun.d_birth ? new Date(fun.d_birth).toShortFormat() : '';
                    row.d_place_birth = fun.d_place_birth;
                    row.d_death = fun.d_death ? new Date(fun.d_death).toShortFormat() : '';
                    row.d_place_death = fun.d_place_death;
                    row.date_funeral = fun.date_funeral ?  new Date(fun.date_funeral).toShortFormatWithTimeExcel() : '';
                    row.d_id = fun.d_id;
                    row.autopsy = fun.evidence ? fun.evidence.autopsy : '';
                    row.d_dangerous_disease = fun.evidence ? fun.evidence.d_dangerous_disease : '';
                    row.planned_pickup = fun.planned_pickup ? new Date(fun.planned_pickup).toShortFormatWithTimeExcel() : '';
                    row.items = fun.evidence ? fun.evidence.items : '';
                    row.placement_fridge = fun.evidence ? (fun.evidence.placement_fridge ? new Date(fun.evidence.placement_fridge).toShortFormatWithTimeExcel() : '') : '';
                    row.car_id = fun.evidence ? fun.evidence.car_id : '';
                    row.temperature = fun.evidence ? fun.evidence.temperature : '';
                    row.disinfection = fun.evidence ? fun.evidence.disinfection : '';
                    row.disinfection_date = fun.evidence ? (fun.evidence.disinfection_date ? new Date(fun.evidence.disinfection_date).toShortFormatWithTimeExcel() : '') : '';
                    row.employee = fun.evidence ? fun.evidence.employee : '';
                    row.employee_money = fun.evidence ? fun.evidence.employee_money : '';
                    row.employee_transfer = fun.evidence ? fun.evidence.employee_transfer : '';
                    row.employee_clothes = fun.evidence ? fun.evidence.employee_clothes : '';
                    row.employee_funeral = fun.evidence ? fun.evidence.employee_funeral : '';
                    row.placement_of_decedent = fun.evidence ? fun.evidence.placement_of_decedent : '';
                    row.urn_number = fun.evidence ? fun.evidence.urn_number : '';
                    row.cremation_datetime = fun.evidence ? (fun.evidence.cremation_datetime ? new Date(fun.evidence.cremation_datetime).toShortFormatWithTimeExcel() : '') : '';
                    return row;
                })
                setValues(rows);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }

    const handleChange = (e) => {
        if(isNaN(e.target.value)){
            NotificationManager.error('Zadajte rok! (napr.: 2021)', 'Chyba', 5000);
        }
        setYear(e.target.value);
    }

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <Title>Export dát evidencie</Title>
                </div>

                <div className={localClasses.controlsRow}>
                    <div className={localClasses.yearInput}>
                        <TextInput
                            label="Rok pre generovanie"
                            name={'year'}
                            type="number"
                            value={year}
                            onChange={handleChange}
                            fullWidth
                        />
                    </div>
                    <Button className={classes.primaryAction} onClick={handleFetchYear}>
                        Načítať dáta
                    </Button>
                </div>

                <div className={localClasses.dataGridWrap}>
                    <DataGrid
                        rows={values}
                        columns={columns}
                        disableSelectionOnClick
                        disableColumnSelector
                        disableColumnFilter
                        disableColumnMenu
                        disableMultipleColumnsSorting
                        pageSize={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        components={{
                            Toolbar: CustomToolbar,
                        }}
                    />
                </div>
                <Typography component="div" className={localClasses.helperLink}>
                    <Link to="/navod_excel">
                        Ak sú vaše dáta nečitateľné, tu nájdete návod na otvorenie vygenerovaného súboru v programe Google Sheets.
                    </Link>
                </Typography>
            </Paper>
        </Container>
    );
}
